import { Decoration } from "@codemirror/view";
import { syntaxTree } from "@codemirror/language";

import { hiddenDecoration, shouldHideMarkers } from "../utils/decorationHelper";

import { 
  findMarkerPositions
} from "../utils/decorationHelper";

export function decorateListMark(node, view, widgets, { markTypeName, contentClass, mode = "edit" }) {
  if (node.from >= node.to) return false;

  const tree = syntaxTree(view.state);
  let isOrderedList = false;
  let isBulletList = false;

  // Find marker positions using extracted method
  const { markStart } = findMarkerPositions(tree, node.from, node.to, markTypeName);

  // Check for list types
  tree.iterate({
    from: node.from,
    to: node.to,
    enter: (nodeRef) => {
      if (nodeRef.type.name === "OrderedList") {
        isOrderedList = true;
      }
      if (nodeRef.type.name === "BulletList") {
        isBulletList = true;
      }
    },
  });

  // If it's an ordered list, don't push any decoration
  if (isOrderedList) {
    widgets.push(Decoration.mark({ class: "cm-markdoc-list-number" }).range(markStart.from, markStart.to));
    return false;
  }

  // For bullet list or other elements with a valid markStart
  const markStartContent = markStart ? view.state.doc.sliceString(markStart.from, markStart.to) : null;

  if (markStart) {
    widgets.push(Decoration.mark({ class: "cm-markdoc-list-bullet" }).range(markStart.from, markStart.to));
    return true;
  }

  return false;
}
